<template lang="pug">
.l-content
  .c-container
    .c-container__image.u-text-center
      img(src="@/assets/img/logo/logo-square.png", alt="gigbase")

    .c-container__heading.m-ptxl
      p プロフィール登録が
      p 完了しました。
    .c-container__annotation ログインしてギグベースを始めましょう。
    .c-container__annotation 本人確認が完了すると、お仕事の応募・受託が可能になります。

    FloatingBeginButton(@click="handleBegin")
</template>

<script lang="babel">
import nativeMethodDispatcher from "@/utils/nativeMethodDispatcher";
import {defineComponent} from "vue";
import {useGtag} from "@/composables/useGtag";
import {usePlatformType} from "@/composables/usePlatformType";
import FloatingBeginButton from "@/components/signup/FloatingBeginButton";
import {useAppStoreOpener} from "@/composables/signup";

export default defineComponent({
  name: 'Completed',
  components: { FloatingBeginButton },
  setup(_, { emit }) {
    emit('page-navbar', false);

    const gtag = useGtag()
    const { isNative } = usePlatformType()
    const { openAppStore } = useAppStoreOpener()

    const handleBegin = () => {
      if (isNative()) {
        nativeMethodDispatcher.dispatch('login');
      } else {
        gtag.event('completedSignup', { event_category: 'signup' });
        openAppStore()
      }
    }

    return { handleBegin }
  }
})
</script>

<style scoped lang="scss">
.l-content {
  height: 100%;
  margin-top: 60px;
}

.c-container {
  padding: 25px 32px 0;

  &__image > img {
    width: 160px;
  }

  &__heading {
    margin-bottom: 48px;
    font-size: 22px;
    font-weight: bold;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.03em;
    color: #222222;
  }

  &__annotation {
    padding-bottom: 16px;
    font-size: 14px;
    line-height: 26px;
    letter-spacing: 0.03em;
    color: #4E4B4B;
  }

  &__button-wrapper {
    position: fixed;
    left: 0;
    bottom: 0;

    width: 100%;
    padding: 0 40px 62px;
  }
  &__button {
    background-color: #F94848;
    color: white;

    border-radius: 60px;
    border: none;

    font-size: 14px;
    font-weight: 500;

    width: 100%;
    padding: 18px 0;
  }
}
</style>
